module.exports = __webpack_public_path__ + "static/media/Slide96.e5f61659.JPG";